module.exports = __webpack_public_path__ + "static/img/e2.d445d2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/e2.png
// module id = 4D2g
// module chunks = 1